<div class="flex-direction-column height-100 page">
  <div class="flex-direction-row justify-between align-center">
    <app-form-field style="margin-right: 1%" placeholder="Pesquisar" iconPrefix="search" iconColor="var(--primary)" backgroundColor="transparent" classe="pesquisar"
                    widthFormField="325px" heightFormField="35px" borderColor="var(--primary)"></app-form-field>
  </div>

  @if (pesquisas.length > 0) {
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="acao">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="flex-direction-row gap-5">
            @if (elemento.statusPesquisa.includes('Sem Resposta')) {
              <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                                 widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(false, elemento)"></app-button-padrao>
            }

            <app-button-padrao iconSrc="icones/visualizar" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="20px" heightIcon="20px" (buttonClick)="abrirModal(true, elemento)"></app-button-padrao>

            @if (elemento.statusPesquisa.includes('Sem Resposta')) {
              <app-button-padrao iconSrc="icones/fluxo" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                                 widthIcon="20px" heightIcon="20px" (buttonClick)="selecionarFluxo(elemento)"></app-button-padrao>
            }

            @if (!elemento.statusPesquisa.includes('Finalizado')) {
              <app-button-padrao iconSrc="icones/pesquisa" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                                 widthIcon="20px" heightIcon="20px" (buttonClick)="finalizarFluxo(elemento)"></app-button-padrao>
            }

            <app-button-padrao iconSrc="icones/copy-icon" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                               widthIcon="20px" heightIcon="20px" (buttonClick)="clonarFluxo(elemento)"></app-button-padrao>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef>
          <p>ID</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start">
          <p class="ellipse">{{ elemento?.id || '-' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="titulo">
        <mat-header-cell *matHeaderCellDef>
          <p>Título</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.titulo || '' }}">
          <p class="ellipse">{{ elemento?.titulo || '-' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="circulo" style="margin-right: 5px" [ngStyle]="elemento.ativo ? {'background-color': '#61B460'} : {'background-color': '#C60000'}"></div>
          {{ elemento.ativo ? 'Ativo' : 'Inativo' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="statusPesquisa">
        <mat-header-cell *matHeaderCellDef>Status Pesquisa</mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <div class="circulo" style="margin-right: 5px" [ngStyle]="elemento.statusPesquisa === 'Sem Resposta' ? {'background-color': '#C60000'} :  elemento.statusPesquisa === 'Com Resposta' ? {'background-color': '#A6CE35'} : {'background-color': 'var(--primary)'}"></div>
          {{ elemento.statusPesquisa }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <mat-header-cell *matHeaderCellDef>
          <p>Descrição</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="ellipse" matTooltip="{{ elemento?.descricao || '' }}">
          {{ elemento?.descricao || '-' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuarioCriacao">
        <mat-header-cell *matHeaderCellDef>
          <p>Usuário Criação</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.usuarioCriacao?.nome || '' }}">
          <p class="ellipse">{{ elemento?.usuarioCriacao?.nome || '-' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataCriacao">
        <mat-header-cell *matHeaderCellDef>Data Criação</mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          {{ elemento?.dataCriacao ? (elemento.dataCriacao | date: 'dd/MM/yyyy HH:mm') : '-' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuarioAlteracao">
        <mat-header-cell *matHeaderCellDef>
          <p>Usuário Alteração</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let elemento" class="center-start" matTooltip="{{ elemento?.usuarioAlteracao?.nome || '' }}">
          <p class="ellipse">{{ elemento?.usuarioAlteracao?.nome || '-' }}</p>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataAlteracao">
        <mat-header-cell *matHeaderCellDef>Data Alteração</mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          {{ elemento?.dataAlteracao ? (elemento.dataAlteracao | date: 'dd/MM/yyyy HH:mm') : '-' }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="colunas"></mat-header-row>
      <mat-row *matRowDef="let row; columns: colunas;"></mat-row>
    </mat-table>
  } @else {
    <div class="flex center-center height-100">
      <img style="height: 394px; width: 582px;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="Nenhuma pesquisa encontrada">
    </div>
  }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" alt="Adicionar pesquisa" role="button" tabindex="0" (click)="abrirModal(false)" (keydown.enter)="abrirModal(false)" />
</div>
